module.exports = __webpack_public_path__ + "img/Lotsengruppe.ac8c4558.svg";